import React from  'react';

const RowConfigRow = (props) =>
{


    const key = Object.keys(props.rowData)[0];
    const label = props.rowData[key][0].label;
    const rows = props.rowData[key].map((row) => <td>{ row && row.value ? row.value: '---'}</td>);
    return (
        <tr>
            <th>{label}</th>
            {rows}
        </tr>
    );
}

export default RowConfigRow